import { Shapes } from '@/components/public/Visualisations/types'
import { AxisTickText } from '@/components/public/Visualisations/XYBubbles/Entities/Axis/AxisTickText'
import { YAxisLabelText } from '@/components/public/Visualisations/XYBubbles/Entities/Axis/YAxisLabelText'
import { YAxisLine } from '@/components/public/Visualisations/XYBubbles/Entities/Axis/YAxisLine'
import { Axes, YAxisProps } from '@/components/public/Visualisations/XYBubbles/types'
import { Coordinate2D, Path } from '@/types'
import Konva from 'konva'

export class YAxisGroup extends Konva.Group implements Shapes.Group {
  private _line: YAxisLine
  private _ticks: Record<number | string, AxisTickText> = {}
  private _label: YAxisLabelText

  entities: Shapes.Entity[] = []
  key: string = 'axis-group'
  path: Path = new Path({})
  center: Coordinate2D = this.position()
  capabilities: Shapes.Capability[] = []
  refresh: () => void = () => {}
  props!: YAxisProps

  constructor() {
    super()
    this._line = new YAxisLine()
    this.addShape(this._line)

    this._label = new YAxisLabelText()
    this.addShape(this._label)
  }

  get maxLabelWidth() {
    return Math.max(...Object.values(this._ticks).map((tick) => tick.width()))
  }

  get minTickAbsoluteLeft() {
    return Math.min(...Object.values(this._ticks).map((tick) => tick.getAbsolutePosition().x))
  }

  update(props: YAxisProps) {
    this.props = props
    this._line.update(props)
    this._label.update(props)
    this.clearTicks()

    props.ticks?.forEach((tick) => {
      const tickText = new AxisTickText(Axes.y)
      this._ticks[tick.value] = tickText
      this.addShape(tickText)

      this._ticks[tick.value].update(tick)
    })
  }

  updateHorizontalOffset(offset: number) {
    this.entities.forEach((entity) => entity.offsetX(offset))
  }

  private addShape(shape: Shapes.Shape) {
    this.entities.push(shape)
    this.add(shape)
  }

  private clearTicks() {
    Object.values(this._ticks).forEach((tick) => {
      tick.remove()
    })
    this.entities = this.entities.filter((entity) => !(entity instanceof AxisTickText))
    this._ticks = {}
  }
}
